<template>
  <v-menu
    offset-x
    :disabled="disablePopover"
    :nudge-top="20"
    :nudge-right="8"
    :close-on-content-click="false"
    open-on-hover
    open-delay="300"
  >
    <template #activator="{ on, attrs }">
      <avatar
        v-bind="attrs"
        :size="size"
        :text-size="textSize"
        :on="on"
        @click.native.prevent
      >
        {{ initials }}
      </avatar>
    </template>
    <v-card>
      <div class="pa-4 d-flex">
        <avatar class="mr-2" :size="size" :text-size="textSize">
          {{ initials }}
        </avatar>
        <div>
          <div>{{ name }}</div>
          <div class="caption">{{ email }}</div>
        </div>
      </div>
    </v-card>
  </v-menu>
</template>

<script>
import Avatar from './Avatar';
import { Researcher, ReviewMemberInvite } from '@/models';

const defaultStyle = {
  size: 48,
  textSize: 16,
};
const mediumStyle = {
  size: 40,
  textSize: 14,
};
const smallStyle = {
  size: 28,
  textSize: 10,
};

export default {
  name: 'ResearcherAvatar',
  components: { Avatar },
  props: {
    researcher: {
      type: Researcher,
      default: null,
    },
    reviewMemberInvite: {
      type: ReviewMemberInvite,
      default: null,
    },
    medium: {
      type: Boolean,
      default: false,
    },
    small: {
      type: Boolean,
      default: false,
    },
    disablePopover: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({ popover: false }),
  computed: {
    name() {
      // Falls back to a placeholder when the subject has been deleted (e.g. the
      // author of a comment/vote whose reviewer FK is now null).
      return (
        this.researcher?.name ||
        this.reviewMemberInvite?.emailAddress ||
        'Deleted user'
      );
    },
    email() {
      return (
        this.researcher?.email ||
        this.reviewMemberInvite?.emailAddress
      );
    },
    initials() {
      const names = this.name.split(' ');
      if (names.length > 1) {
        const firstInitial = names[0].charAt(0).toUpperCase();
        const lastInitial = names[1].charAt(0).toUpperCase();
        return firstInitial + lastInitial;
      }
      return this.name.charAt(0).toUpperCase();
    },
    style() {
      if (this.medium) {
        return mediumStyle;
      } else if (this.small) {
        return smallStyle;
      }
      return defaultStyle;
    },
    size() {
      return this.style.size;
    },
    textSize() {
      return this.style.textSize;
    },
  },
};
</script>
